import { createClient, type SupabaseClient as SupabaseClientType } from '@supabase/supabase-js';
import { config } from '@/api/config';

function createSupabaseClient(): SupabaseClientType {
  if (!config.supabase.url || !config.supabase.anonKey) {
    throw new Error(
      'Supabase configuration missing. Create a .env.local file with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY. See .env.example for reference.',
    );
  }

  return createClient(config.supabase.url, config.supabase.anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
}

export const supabase = createSupabaseClient();

export type SupabaseClient = typeof supabase;
